import { IBase, IBaseSearchRequest } from "../../core/models/base";

// Numeric enum to match the backend (System.Text.Json serializes enums as numbers).
export enum ExpenseTypeKind {
  KmExpense = 0,
  CashExpense = 10
}

export interface IExpenseType extends IBase {
  name: string;
  type: ExpenseTypeKind;
  kmRate?: number | null;
  flatrate?: number | null;
  salaryPayment: boolean;
  requiresReceipt: boolean;
}

export interface ICreateExpenseTypeRequest {
  name: string;
  type: ExpenseTypeKind;
  kmRate?: number | null;
  flatrate?: number | null;
  salaryPayment: boolean;
  requiresReceipt: boolean;
}

export interface IUpdateExpenseTypeRequest extends ICreateExpenseTypeRequest {
  id: string;
}

export interface ISearchExpenseTypesRequest extends IBaseSearchRequest {
}
